import { createContext, useContext } from 'react'

/**
 * True while the page-level "Edit all fields" toggle is on. Every inline field
 * reads it: unlocked at once, no pencil to click, and the page's own Save does
 * the saving. Off by default, so the per-field pencil flow is unchanged.
 */
export const EditAllContext = createContext<boolean>(false)

export const useEditAll = (): boolean => useContext(EditAllContext)
